<template>
    <div>
        <modal :name="modal_name" class="final-modal success-vmodal modal-height" transition="nice-modal-fade" :delay="100"  :width="550" :height="320" :pivot-y="0.5" :adaptive="true" :scrollable="false" style="background:transparent; pointer-events:inherit !important" v-bind:click-to-close="false">
            <div class="v-modal-content" style="border-radius: 15px;background:#fff !important;">
                <div class="pt-2 pl-0 pr-0 pb-1 m-4">
                    <div class="v-modal-body pt-0 pb-0" style="min-height: 450px;overflow-x: hidden;overflow-y: auto;">
                        <div class="d-form" style="overflow: initial !important;">
                            <div  class="text-center" style="height:250px">
                                <img src="/static/images/enterprise-application-development-services@3x.png" alt="" height="150px">
                                <div class="text-secondary fw-600 fs-16 pt-2 pb-2">Yay!</div>
                                <div class="text-dark fs-14 pt-2 pb-2"> 
                                    The selected Member(s) are now added <br> to 
                                    <span v-if="selected_team_name.name"> {{selected_team_name.name}}</span>
                                    <span v-else> {{selected_team_name}}</span> Team 
                                </div>
                            </div>
                        </div>
                        <!-- <div class="d-flex justify-content-center">
                            <button type="button" class="btn ok-button btn-smm text-white ml-4" @click="okClicked" style="box-shadow: none;">
                                OK
                            </button>
                        </div> -->
                    </div>
                </div>
            </div>
        </modal>
    </div>  
</template>
<script>
// import { EventBus } from '../eventBus/nav-bar-event'
export default {
    props:['modal_name', 'message',"selected_team_name"],
    data(){
        return{
        }
    },
    methods:{
        okClicked() {
            setTimeout(() => {
                this.$modal.hide(this.modal_name);
            }, 1000);
            this.$emit("hideSuccess");
        }
    },
    mounted(){
    }
}
</script>
<style scoped>
    .ok-button{
        background-color: #00448b !important;
        color: #fff !important;
    }
   
</style>


// WEBPACK FOOTER //
// src/components/alertModals/AddMembersSuccessful.vue